import { Platform } from 'react-native'

import {
  Poppins_300Light,
  Poppins_400Regular,
  Poppins_500Medium,
  Poppins_600SemiBold,
  useFonts as useFontsRn
} from '@expo-google-fonts/poppins'
import {
  Roboto_300Light,
  Roboto_400Regular,
  Roboto_500Medium,
  Roboto_700Bold,
  Roboto_900Black,
  useFonts as useFontsRnRoboto
} from '@expo-google-fonts/roboto'

// On web a family without the glyph falls back to the browser default font,
// usually a serif: Poppins has no Cyrillic (ru) and no CJK. So on web each
// family is a stack: Roboto of a close weight (has Cyrillic), then the system
// sans-serif, which picks the CJK font for <html lang> (set by localization.ts).
// Native takes a single family and falls back per glyph on its own.
const SYSTEM_SANS = 'system-ui, -apple-system, "Segoe UI", sans-serif'
const withFallback = (family: string, fallback: string) =>
  Platform.OS === 'web' ? `${family}, ${fallback}` : family

// eslint-disable-next-line @typescript-eslint/naming-convention
export const FONT_FAMILIES = {
  LIGHT: withFallback('Poppins_300Light', `Roboto_300Light, ${SYSTEM_SANS}`),
  REGULAR: withFallback('Poppins_400Regular', `Roboto_400Regular, ${SYSTEM_SANS}`),
  MEDIUM: withFallback('Poppins_500Medium', `Roboto_500Medium, ${SYSTEM_SANS}`),
  SEMI_BOLD: withFallback('Poppins_600SemiBold', `Roboto_500Medium, ${SYSTEM_SANS}`)
} as const

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ROBOTO_FONT_FAMILIES = {
  LIGHT: withFallback('Roboto_300Light', SYSTEM_SANS),
  REGULAR: withFallback('Roboto_400Regular', SYSTEM_SANS),
  MEDIUM: withFallback('Roboto_500Medium', SYSTEM_SANS),
  BOLD: withFallback('Roboto_700Bold', SYSTEM_SANS),
  BLACK: withFallback('Roboto_900Black', SYSTEM_SANS)
} as const

export interface UseFontsReturnType {
  fontsLoaded: boolean
  robotoFontsLoaded: boolean
}

export default function useFonts(): UseFontsReturnType {
  // Import only the ones that are used, because having all could lead to a performance
  // penalty, since loading of the fonts take some time during initial app open.
  const [fontsLoaded] = useFontsRn({
    // Poppins_100Thin,
    // Poppins_100Thin_Italic,
    // Poppins_200ExtraLight,
    // Poppins_200ExtraLight_Italic,
    Poppins_300Light,
    // Poppins_300Light_Italic,
    Poppins_400Regular,
    // Poppins_400Regular_Italic,
    Poppins_500Medium,
    // Poppins_500Medium_Italic,
    Poppins_600SemiBold
    // Poppins_600SemiBold_Italic,
    // Poppins_700Bold,
    // Poppins_700Bold_Italic,
    // Poppins_800ExtraBold,
    // Poppins_800ExtraBold_Italic,
    // Poppins_900Black,
    // Poppins_900Black_Italic
  })

  const [robotoFontsLoaded] = useFontsRnRoboto({
    Roboto_300Light,
    Roboto_400Regular,
    Roboto_500Medium,
    Roboto_700Bold,
    Roboto_900Black
  })

  return { fontsLoaded, robotoFontsLoaded }
}
